import Vue from "vue";
import Vuex from "vuex";

import api from "../services/api";
import user from "../services/user";
import cart from "../services/cart";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		isLogged: false,
		userInfo: {
			id: "",
			email: "",
			name: {
				firstname: "",
				lastname: ""
			}
		},
		storeInfo: null,
		cartItems: {},
		alertInfo: {
			msg: "",
			color: "",
			duration: 0
		}
	},
	getters: {
		isLogged(state) {
			return state.isLogged;
		},
		userInfo(state) {
			return state.userInfo;
		},
		storeInfo(state) {
			return state.storeInfo;
		},
		alertInfo(state) {
			return state.alertInfo;
		},
		cartItems(state) {
			return state.cartItems;
		}
	},
	mutations: {
		SET_LOGGED_IN(state, { userInfo, storeInfo }) {
			state.isLogged = true;
			state.userInfo = userInfo;
			state.storeInfo = storeInfo;
		},
		SET_USER_INFO(state, { userInfo, storeInfo }) {
			state.userInfo = userInfo;
			state.storeInfo = storeInfo;
		},
		SET_LOGGED_OUT(state) {
			state.isLogged = false;
			state.userInfo = { name: {} };
			// Clear userInfo
		},
		SET_ALERT(state, value) {
			state.alertInfo = value;
		},
		SET_CART_ITEM(state, cartItems) {
			state.cartItems = cartItems;
		}
	},
	actions: {
		async Login({ commit, dispatch }, { email, password, remember }) {
			let account = await user.login({ email, password, remember });
			if (account.success) {
				commit("SET_LOGGED_IN", account);
			}
			return account;
		},
		// $store.dispatch('RefreshUser')
		async RefreshUser({ commit }) {
			let account = await user.getProfile();
			if (account && account.userInfo) {
				commit("SET_LOGGED_IN", account);
			}
		},
		UpdateUserInfo({ commit }, { account }) {
			if (account) {
				user.updateLoginInfo(account);
				commit("SET_USER_INFO", account);
			}
		},
		Logout({ commit }) {
			user.logout();
			commit("SET_LOGGED_OUT");
		},
		Restore({ commit }) {
			let { userInfo, storeInfo, cartItems } = user.restore();
			if (userInfo) { commit("SET_LOGGED_IN", { userInfo, storeInfo }); }
			if (cartItems) { commit("SET_CART_ITEM", cartItems); }
		},
		async GetRoute({ }, { query } = {}) {
			return await api.getRoute(query);
		},
		EditItem({ commit }, { cartItem, removeItem }) {
			let cartItems;
			if (cartItem) {
				cartItems = cart.addItem(cartItem);
			} else {
				cartItems = cart.removeItem(removeItem);
			}
			commit("SET_CART_ITEM", cartItems);
		},
		MakeAlert({ commit }, { msg, color, duration }) {
			commit("SET_ALERT", { msg, color, duration });
		}
	},
	modules: {}
});
